<section class="container-02">
  <div class="call-out-content p-horizontal">
  <blockquote>“{{cueElement.headline}}”</blockquote>
    <p class="small call-out-name" *ngIf="cueElement.authorName"><b>{{cueElement.authorName}}</b></p>
    <p class="small call-out-job" *ngIf="cueElement.authorTitle">{{cueElement.authorTitle}}</p>
  </div>
</section>
